module.exports = __webpack_public_path__ + "static/media/Gardening Lawn Mower 1.3bd16c23.svg";